<template>
  <div class="personnel">
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div v-if="currentUserAccess('ProjectLogs',this.UserActions.CREATE,this.project_id)" class="column">
            <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                      @click="addNewPersonalWorklogClicked">
              {{ $t('personnel-worklogs.new-personal-log-button') }}
            </b-button>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <b-table class="personnel-worklogs-table" :data="personnelWorklogsData" :striped="true" :hoverable="true"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="date" :label="this.$t('personnel-worklogs.personal-logdate-column')"
                              v-slot="props">
                {{ props.row.date }}
              </b-table-column>
              <b-table-column field="name" :label="this.$t('personnel-worklogs.personal-fullname-column')"
                              v-slot="props">
                {{ props.row.fullname }}
              </b-table-column>
              <b-table-column field="agency" :label="this.$t('personnel-worklogs.personal-agency-column')"
                              v-slot="props">
                {{ props.row.agency }}
              </b-table-column>
              <b-table-column field="hours" :label="this.$t('personnel-worklogs.personal-hours-column')"
                              v-slot="props">
                {{ getFormattedTimeHour(props.row.personalLog.quantity) }}
              </b-table-column>
              <b-table-column field="hours" :label="this.$t('personnel-worklogs.personal-total-column')"
                              v-slot="props">
                {{ getFormattedTimeHour(props.row.total) }}
              </b-table-column>
              <b-table-column field="text" :label="this.$t('personnel-worklogs.personal-text-column')"
                              v-slot="props">
                {{ props.row.personalLog.text }}
              </b-table-column>
              <b-table-column v-if="currentUserAccess('ProjectLogs',this.UserActions.DELETE,this.project_id)" :label="this.$t('personnel-worklogs.actions-column')" centered v-slot="props">
                <b-tooltip :label="$t('common.edit')" position="is-top">
                  <b-button class="button is-primary is-small mr-2"
                          @click="editPersonalWorklogClicked(props.row.personalLog)" icon-left="pencil">
                  </b-button>
                </b-tooltip>
                <b-tooltip :label="$t('common.delete')" position="is-top">
                  <b-button class="button is-primary is-danger is-small"
                          @click="deletePersonalWorklogClicked(props.row.personalLog)" icon-left="delete">
                  </b-button>
                </b-tooltip>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isPersonalWorklogModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <PersonalWorklog v-bind:project_id="project_id" v-bind:personnel_data="personnelData" v-bind:log_data="selected_log" v-bind:selected_date="selected_date" @close="props.close"
                           @personalWorklogAdded="readPersonnelWorklogsData" @personalWorklogUpdated="readPersonnelWorklogsData"></PersonalWorklog>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>

import firebase from "firebase/app";
import PersonalWorklog from "@/components/PersonalWorklog";

export default {
  name: "PersonnelWorklogs",
  components: {
    PersonalWorklog
  },
  props: {
    'project_id': {
      type: String,
    },
    'selected_date': {}
  },
  data() {
    return {
      modelDate: new Date(),
      selectedUntilDate: new Date((new Date()).setHours(23, 59, 59, 0)),
      selectedFromDate: new Date((new Date()).setHours(0, 0, 0, 0)),
      personnelData: [],
      personnelWorklogsData: [],
      isLoading: false,
      isPersonalWorklogModalActive: false,
      selected_log: {}
    }
  },
  watch: {
    selected_date: function () {
      this.dateSelectClicked(this.selected_date)
    }
  },
  methods: {
    readPersonnelData: function () {
      this.personnelData = [];
      const functions = firebase.app().functions("europe-west3");
      const getPersonnelFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getPersonnelFunction({action: "get_personnel", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("personnel list result: ", result.data);
            if (result.data.personnel.length > 0) {
              result.data["personnel"].forEach((personal) => {
                this.personnelData.push({
                  personal: personal,
                  fullname: this.getFullName(personal.name),
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting personnel: ", error);
          });
    },
    readPersonnelWorklogsData: function () {
      this.isPersonalWorklogModalActive = false;
      this.isLoading = true;
      this.personnelWorklogsData = [];
      this.selected_log = {};
      this.selected_log.document_id = "new"
      const functions = firebase.app().functions("europe-west3");
      const getPersonnelLogsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payloadData = {
        action: "get_logs",
        project_id: this.project_id,
        personal_id: "*",
        fill_meta: true,
        filters: [['date', '>', this.selectedFromDate.toISOString()], ['date', '<', this.selectedUntilDate.toISOString()]]
      }
      getPersonnelLogsFunction(payloadData)
          .then((result) => {
            console.log("personnel work logs list result: ", result.data);
            if (result.data.personnellogs.length > 0) {
              result.data["personnellogs"].forEach((personalLog) => {
                this.personnelWorklogsData.push({
                  personalLog: personalLog,
                  total: personalLog.parent.logged_quantities,
                  fullname: this.getFullName(personalLog.parent.name),
                  agency: personalLog.parent.agency,
                  date: this.getFormattedDate(personalLog.date),
                  document_id: personalLog.document_id
                });
              });
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(error.message)
            console.log("Error getting logs: ", error);
          });
    },
    deletePersonalWorklog: function (personalLog) {
      this.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const deletePersonalLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      deletePersonalLogFunction({
        action: "delete_log",
        project_id: personalLog.project_id,
        personal_id: personalLog.personal_id,
        document_id: personalLog.document_id,
      }).then(() => {
        this.isLoading = false;
        this.showSuccess(this.$t('messages.personal-log-deleted'));
        this.readPersonnelWorklogsData()
      }).catch((error) => {
        this.isLoading = false;
        this.showError(error.message)
        console.log("Error deleting worklog: ", error);
      });
    },
    /*
     UI Events
     */
    dateSelectClicked: function (date) {
      const fromDate = date.setHours(0, 0, 0, 0)
      const untilDate = date.setHours(23, 59, 59, 0)
      this.selectedFromDate = new Date(fromDate)
      this.selectedUntilDate = new Date(untilDate)
      this.readPersonnelWorklogsData();
    },
    addNewPersonalWorklogClicked: function () {
      this.selected_log = {};
      this.selected_log.document_id = "new";
      this.isPersonalWorklogModalActive = true;
    },
    editPersonalWorklogClicked: function (personalLog) {
      this.selected_log = personalLog;
      this.isPersonalWorklogModalActive = true;
    },
    deletePersonalWorklogClicked: function (personalLog) {
      this.$buefy.dialog.confirm({
        title: this.$t('personnel-worklogs.delete-log-title').toString(),
        message: this.$t('personnel-worklogs.delete-log-message').toString(),
        confirmText: this.$t('personnel-worklogs.delete-log-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deletePersonalWorklog(personalLog);
        }
      });
    }
  },
  mounted() {
    this.readPersonnelData()
    this.readPersonnelWorklogsData();
  }
};
</script>

<style scoped>
.personnel-worklogs-table {
  margin-top: 16px;
}
</style>
